import labels from './labels/labels-ja';

const minX = 0;
const maxX = 1000;
const padding = 100;
const nodeWidth = 150;
const nodeHeight = 45;

const primary = {borderColor: "#8899D2", backgroundColor: "#8899D2", color: "#FFF", fontSize: 13};
const secondary = {borderColor: "#8AE395"};
const ternary = {borderColor: "#75AFFF", backgroundColor: "#75AFFF", color: "#FFF"};
const quaternary = {borderColor: "#9399F4"};
const green = {borderColor: "#27ae60", backgroundColor: "#27ae60", color: "#FFF"};
const dark = {borderColor: "#2c3e50", backgroundColor: "#2c3e50", color: "#FFF"};
const red = {borderColor: "#c0392b", backgroundColor: "#c0392b", color: "#FFF"};

const whiteBox = {borderColor: "#a2a2a2", backgroundColor: "#FFF"};

const recommendBoxStyle = {top: '-18px', right: '-1px', backgroundColor: '#ededed', border: '1px solid #3d3636', padding: '0px 5px', fontSize: '8px', borderRadius: '2px', color: "#000"};

let nodes = [
    {
        id: 'start',
        type: 'LMRTNode',
        data: { label: labels.start },
        position: { x: maxX * 0.60, y: nodeHeight - (nodeHeight * 2) },
        style: { opacity: "0" },
    },
    {
        id: 'A',
        type: 'LMRTNode',
        data: { label: labels.pickLanguage, topLeftText: '<span style="margin-left: 2px;">①</span>' },
        position: { x: maxX * 0.60, y: nodeHeight },
        style: primary
    },
    {
        id: 'Javascript',
        type: 'LMRTNode',
        data: { label: labels.javascript, topRightText: labels.recommended, topRightStyle: recommendBoxStyle},
        position: { x: maxX * 0.95 , y: nodeHeight - (nodeHeight * 4) },
        style: green
    },
    {
        id: 'Python',
        type: 'LMRTNode',
        data: { label: labels.python, topRightText: labels.recommended, topRightStyle: recommendBoxStyle },
        position: { x: maxX * 0.95 , y: nodeHeight - (nodeHeight * 3) },
        style: green
    },
    {
        id: 'PHP',
        type: 'LMRTNode',
        data: { label: labels.php },
        position: { x: maxX * 0.95, y: nodeHeight - (nodeHeight * 2)},
        style: dark
    },
    {
        id: 'Ruby',
        type: 'LMRTNode',
        data: { label: labels.ruby },
        position: { x: maxX * 0.95, y: nodeHeight - (nodeHeight)},
        style: dark
    },
    {
        id: 'Java',
        type: 'LMRTNode',
        data: { label: labels.java, topRightText: labels.advanced, topRightStyle: recommendBoxStyle },
        position: { x: maxX * 0.95, y: nodeHeight},
        style: red
    },
    {
        id: 'Typescript',
        type: 'LMRTNode',
        data: { label: labels.typescript, topRightText: labels.advanced, topRightStyle: recommendBoxStyle },
        position: { x: maxX * 0.95, y: nodeHeight + nodeHeight},
        style: red
    },
    {
        id: 'CSharp',
        type: 'LMRTNode',
        data: { label: labels.csharp, topRightText: labels.advanced, topRightStyle: recommendBoxStyle },
        position: { x: maxX * 0.95, y: nodeHeight + (nodeHeight * 2)},
        style: red
    },
    {
        id: 'Go',
        type: 'LMRTNode',
        data: { label: labels.go, topRightText: labels.advanced, topRightStyle: recommendBoxStyle },
        position: { x: maxX * 0.95, y: nodeHeight + (nodeHeight * 3)},
        style: red
    },
    {
        id: 'CPP',
        type: 'LMRTNode',
        data: { label: labels.cpp, topRightText: labels.advanced, topRightStyle: recommendBoxStyle },
        position: { x: maxX * 0.95, y: nodeHeight + (nodeHeight * 4)},
        style: red
    },
];

let currPos = nodeHeight * 6;

// #### CS Beginner (30) -> How to program?, What is data?, What are bits?, Basic Data Types, Functions
nodes.push(
    ...[
        {
            id: 'B',
            type: 'LMRTNode',
            data: { label: labels.cs_beginner, topLeftText: '<span style="margin-left: 2px;">②</span>' },
            position: { x: maxX * 0.2, y: currPos },
            style: primary
        },
        {
            id: 'B1',
            type: 'LMRTNode',
            data: { label: labels.how_to_program },
            position: { x: maxX * 0.45 , y: currPos - (nodeHeight * 2)},
            targetPosition: 'left',
            style: ternary
        },
        {
            id: 'B2',
            type: 'LMRTNode',
            data: { label: labels.what_is_data },
            position: { x: maxX * 0.45 , y: currPos - nodeHeight},
            targetPosition: 'left',
            style: ternary
        },
        {
            id: 'B3',
            type: 'LMRTNode',
            data: { label: labels.what_are_bits },
            position: { x: maxX * 0.45 , y: currPos},
            targetPosition: 'left',
            style: ternary
        },
        {
            id: 'B4',
            type: 'LMRTNode',
            data: { label: labels.basic_data_types },
            position: { x: maxX * 0.45 , y: currPos + nodeHeight},
            targetPosition: 'left',
            style: ternary
        },
        {
            id: 'B4-1',
            type: 'LMRTNode',
            data: { label: labels.boolean },
            position: { x: maxX * 0.70 , y: currPos - nodeHeight},
            targetPosition: 'left',
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'B4-2',
            type: 'LMRTNode',
            data: { label: labels.integer },
            position: { x: maxX * 0.70 , y: currPos},
            targetPosition: 'left',
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'B4-3',
            type: 'LMRTNode',
            data: { label: labels.floating_point },
            position: { x: maxX * 0.70 , y: currPos + nodeHeight},
            targetPosition: 'left',
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'B4-4',
            type: 'LMRTNode',
            data: { label: labels.character },
            position: { x: maxX * 0.70 , y: currPos + (nodeHeight * 2)},
            targetPosition: 'left',
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'B4-5',
            type: 'LMRTNode',
            data: { label: labels.string },
            position: { x: maxX * 0.70 , y: currPos + (nodeHeight * 3)},
            targetPosition: 'left',
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'B5',
            type: 'LMRTNode',
            data: { label: labels.functions },
            position: { x: maxX * 0.45 , y: currPos + (nodeHeight * 2)},
            targetPosition: 'left',
            style: ternary
        },
    ]
);


currPos = nodeHeight * 11;

// #### CS Intermediate (80)
/*
- Abstraction
- How to reuse code?
- Expressing loops using Recursion.
  - Tail Recursion
  - Non-Tail Recursion
- Asymptotic Notation
  - Space & Time Complexity
  - Big O Notation
  - Common Runtimes (Constant, Logarithmic, Linear, Polynomial, Exponential, Factorial)
- Scope
- Control Flow
- For, For Each, and While loops
- List Data Structures
  - Static Fixed Arrays
  - Multi-Dimensional Arrays
  - Dynamic Arrays
  - Hash Tables
    - O(1) Lookups
    - Caching
  - Sorting Algorithms
*/

nodes.push(
    ...[
        {
            id: 'C',
            type: 'LMRTNode',
            data: { label: labels.cs_intermediate, topLeftText: '<span style="margin-left: 2px;">③</span>' },
            position: { x: maxX * 0.2, y: currPos },
            style: primary
        },
        {
            id: 'C1',
            type: 'LMRTNode',
            data: { label: labels.abstraction },
            position: { x: maxX * 0.3 , y: currPos + nodeHeight * 2 },
            style: { ...ternary, ...{width: "200px"}}
        },
        {
            id: 'C2',
            type: 'LMRTNode',
            data: { label: labels.code_reusability },
            position: { x: maxX * 0.3, y: currPos + (nodeHeight * 3) },
            style: { ...ternary, ...{width: "200px"}}
        },
        {
            id: 'C3',
            type: 'LMRTNode',
            data: { label: labels.recursive_functions },
            position: { x: maxX * 0.3, y: currPos + (nodeHeight * 4) },
            style: { ...ternary, ...{width: "200px"}}
        },
        {
            id: 'C3-1',
            type: 'LMRTNode',
            data: { label: labels.tail_recursion },
            position: { x: maxX * 0.12, y: currPos + (nodeHeight * 3.5) },
            style: { ...quaternary, ...{width: "100px"}},
            className: 'quaternary'
        },
        {
            id: 'C3-2',
            type: 'LMRTNode',
            data: { label: labels.non_tail_recursion },
            position: { x: maxX * 0.12, y: currPos + (nodeHeight * 4.5) },
            style: { ...quaternary, ...{width: "100px"}},
            className: 'quaternary'
        },
        {
            id: 'C4',
            type: 'LMRTNode',
            data: { label: labels.asymptotic_notation },
            position: { x: maxX * 0.3, y: currPos + (nodeHeight * 5) },
            style: { ...ternary, ...{width: "200px"}}
        },
        {
            id: 'C4-1',
            type: 'LMRTNode',
            data: { label: labels.space_time_complexity },
            position: { x: maxX * 0.55, y: currPos + (nodeHeight * 4) },
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'C4-2',
            type: 'LMRTNode',
            data: { label: labels.big_o_notation },
            position: { x: maxX * 0.55, y: currPos + (nodeHeight * 5) },
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'C4-3',
            type: 'LMRTNode',
            data: { label: labels.complexity_classes },
            position: { x: maxX * 0.55, y: currPos + (nodeHeight * 6) },
            style: { ...whiteBox, ...{height: nodeHeight * 7, width: "160px"}},
        },
        {
            id: 'C4-3-1',
            type: 'LMRTNode',
            data: { label: labels.constant },
            position: { x: maxX * 0.55 + 5, y: currPos + (nodeHeight * 7) },
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'C4-3-2',
            type: 'LMRTNode',
            data: { label: labels.logarithmic },
            position: { x: maxX * 0.55 + 5, y: currPos + (nodeHeight * 8) },
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'C4-3-3',
            type: 'LMRTNode',
            data: { label: labels.linear },
            position: { x: maxX * 0.55 + 5, y: currPos + (nodeHeight * 9) },
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'C4-3-4',
            type: 'LMRTNode',
            data: { label: labels.polynomial },
            position: { x: maxX * 0.55 + 5, y: currPos + (nodeHeight * 10) },
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'C4-3-5',
            type: 'LMRTNode',
            data: { label: labels.exponential },
            position: { x: maxX * 0.55 + 5, y: currPos + (nodeHeight * 11) },
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'C4-3-6',
            type: 'LMRTNode',
            data: { label: labels.factorial },
            position: { x: maxX * 0.55 + 5, y: currPos + (nodeHeight * 12) },
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'C5',
            type: 'LMRTNode',
            data: { label: labels.scope },
            position: { x: maxX * 0.3, y: currPos + (nodeHeight * 6) },
            style: { ...ternary, ...{width: "200px"}}
        },
        {
            id: 'C6',
            type: 'LMRTNode',
            data: { label: labels.control_flow },
            position: { x: maxX * 0.3, y: currPos + (nodeHeight * 7) },
            style: { ...ternary, ...{width: "200px"}}
        },
        {
            id: 'C7',
            type: 'LMRTNode',
            data: { label: labels.for_for_each_while_loops },
            position: { x: maxX * 0.3, y: currPos + (nodeHeight * 8) },
            style: { ...ternary, ...{width: "200px"}}
        },
        {
            id: 'C8',
            type: 'LMRTNode',
            data: { label: labels.list_structures },
            position: { x: maxX * 0.3, y: currPos + (nodeHeight * 9) },
            style: { ...ternary, ...{width: "200px"}}
        },
        {
            id: 'C8-1',
            type: 'LMRTNode',
            data: { label: labels.fixed_arrays },
            position: { x: maxX * 0.12, y: currPos + (nodeHeight * 6) },
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'C8-2',
            type: 'LMRTNode',
            data: { label: labels.multi_dimensional_arrays },
            position: { x: maxX * 0.12, y: currPos + (nodeHeight * 7) },
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'C8-3',
            type: 'LMRTNode',
            data: { label: labels.dynamic_arrays },
            position: { x: maxX * 0.12, y: currPos + (nodeHeight * 8) },
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'C8-4',
            type: 'LMRTNode',
            data: { label: labels.hash_tables },
            position: { x: maxX * 0.12, y: currPos + (nodeHeight * 9) },
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'C8-5',
            type: 'LMRTNode',
            data: { label: labels.o_1_lookups },
            position: { x: maxX * 0.12, y: currPos + (nodeHeight * 10) },
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'C8-6',
            type: 'LMRTNode',
            data: { label: labels.caching },
            position: { x: maxX * 0.12, y: currPos + (nodeHeight * 11) },
            style: quaternary,
            className: 'quaternary'
        },
        {
            id: 'C8-7',
            type: 'LMRTNode',
            data: { label: labels.sorting_algorithms },
            position: { x: maxX * 0.12, y: currPos + (nodeHeight * 12) },
            style: quaternary,
            className: 'quaternary'
        },
    ]
);

// #### Backend Project 1 (File Manipulator Program) (25)
//- What are Operating Systems?
//   - Resource Management
//   - System Calls
//   - File System
//   - File Descriptors
//   - Unix Commands
// - Linux Distributions - Ubuntu
// - Development Environment
//   - Code Editors
//   - Compiler/Interpreters
//   - Source Control (Git)
// - Compiling & Running Programs
// - CLI Scripting
// - Standard Streams I/O
// #### Backend Project 1 (File Manipulator Program) (25)
//
// #### Git (5)
//
// #### HTML/CSS/Bootstrap (20)
nodes.push(
    ...[
        {
            id: 'D',
            type: 'LMRTNode',
            data: { label: labels.backend_project_1, topLeftText: '<span style="margin-left: 2px;">④</span>', topRightText: labels.project, topRightStyle: recommendBoxStyle },
            position: { x: maxX * 0.75, y: currPos },
            style: primary
        },
        {
            id: 'D1',
            type: 'LMRTNode',
            data: { label: labels.what_are_operating_systems },
            position: { x: maxX * 0.95, y: currPos - (nodeHeight * 2)},
            style: { ...ternary, ...{width: "180px"}},
        },
        {
            id: 'D2',
            type: 'LMRTNode',
            data: { label: labels.linux_distributions },
            position: { x: maxX * 0.95, y: currPos - nodeHeight},
            style: { ...ternary, ...{width: "180px"}},
        },
        {
            id: 'D3',
            type: 'LMRTNode',
            data: { label: labels.development_environment },
            position: { x: maxX * 0.95, y: currPos},
            style: { ...ternary, ...{width: "180px"}},
        },
        {
            id: 'D4',
            type: 'LMRTNode',
            data: { label: labels.cli_scripting },
            position: { x: maxX * 0.95, y: currPos + nodeHeight},
            style: { ...ternary, ...{width: "180px"}},
        },
        {
            id: 'D5',
            type: 'LMRTNode',
            data: { label: labels.standard_stream_io },
            position: { x: maxX * 0.95, y: currPos + (nodeHeight * 2)},
            style: { ...ternary, ...{width: "180px"}},
        },
        {
            id: 'E',
            type: 'LMRTNode',
            data: { label: labels.git, topLeftText: '<span style="margin-left: 2px;">⑤</span>' },
            position: { x: maxX * 0.75, y: currPos + (nodeHeight * 7) },
            style: primary
        },
        {
            id: 'F',
            type: 'LMRTNode',
            data: { label: labels.html_css_bootstrap, topLeftText: '<span style="margin-left: 2px;">⑥</span>' },
            position: { x: maxX * 0.75, y: currPos + (nodeHeight * 14) },
            style: primary
        },
    ]
);

currPos = currPos + nodeHeight * 14;

//
// #### Frontend Project 1 (User Card App) (20)
//
// #### Beginner Frontend Development (Optional) (20)

nodes.push(
    ...[
        {
            id: 'G',
            type: 'LMRTNode',
            data: { label: labels.frontend_project_1, topLeftText: '<span style="margin-left: 2px;">⑦</span>', topRightText: labels.project, topRightStyle: recommendBoxStyle },
            position: { x: maxX * 0.5, y: currPos },
            style: primary
        },
        {
            id: 'G1',
            type: 'LMRTNode',
            data: { label: labels.team_dev_one, topRightText: labels.frontend_optional, topRightStyle: recommendBoxStyle },
            position: { x: maxX * 0.5, y: currPos + (nodeHeight * 1.8) },
            style: green
        },
        {
            id: 'H',
            type: 'LMRTNode',
            data: { label: labels.backend_project_2, topLeftText: '<span style="margin-left: 2px;">⑧</span>', topRightText: labels.project, topRightStyle: recommendBoxStyle },
            position: { x: maxX * 0.2, y: currPos },
            style: primary
        },
        {
            id: 'H1',
            type: 'LMRTNode',
            data: { label: labels.client_server_models },
            position: { x: 0, y: currPos - nodeHeight},
            style: ternary,
        },
        {
            id: 'H2',
            type: 'LMRTNode',
            data: { label: labels.os_process_management },
            position: { x: 0, y: currPos},
            style: ternary,
        },
        {
            id: 'H3',
            type: 'LMRTNode',
            data: { label: labels.ipc },
            position: { x: 0, y: currPos + nodeHeight},
            style: ternary,
        },
        {
            id: 'H4',
            type: 'LMRTNode',
            data: { label: labels.pipes },
            position: { x: 0, y: currPos + (nodeHeight * 2)},
            style: ternary,
        },
        {
            id: 'H5',
            type: 'LMRTNode',
            data: { label: labels.unix_sockets },
            position: { x: 0, y: currPos + (nodeHeight * 3)},
            style: ternary,
        },
        {
            id: 'H6',
            type: 'LMRTNode',
            data: { label: labels.rpc },
            position: { x: 0, y: currPos + (nodeHeight * 4)},
            style: ternary,
        },
        {
            id: 'H7',
            type: 'LMRTNode',
            data: { label: labels.networking_layers },
            position: { x: 0, y: currPos + (nodeHeight * 5)},
            style: ternary,
        },
        {
            id: 'H8',
            type: 'LMRTNode',
            data: { label: labels.udp_tcp },
            position: { x: 0, y: currPos + (nodeHeight * 6)},
            style: ternary,
        },
        {
            id: 'H9',
            type: 'LMRTNode',
            data: { label: labels.team_dev_two, topRightText: labels.backend_optional, topRightStyle: recommendBoxStyle },
            position: { x: maxX * 0.3, y: currPos + (nodeHeight * 1.8) },
            style: green
        },
    ]
);

currPos = currPos + nodeHeight * 6;

// CS Advanced
// - Advanced List Structures
//   - SinglyLinkedList
//   - DoublyLinkedList
//   - Queue
//   - Stacks
//   - Deque
// - Tree Data Structures
//   - Trees
//   - Binary Tree
//   - Binary Search
//   - Balanced Binary Trees
//   - Heaps
// - Graphs
// - Functional Programming
//   - Lambdas
//   - Callable Objects
//   - Higher Order Functions
//   - Closures
// - Testing
nodes.push(
    {
        id: 'I',
        type: 'LMRTNode',
        data: { label: labels.cs_advanced, topLeftText: '<span style="margin-left: 2px;">⑨</span>' },
        position: { x: maxX * 0.2, y: currPos  },
        style: primary
    },
    {
        id: 'I1',
        type: 'LMRTNode',
        data: { label: labels.advanced_list_structures },
        position: { x: maxX * 0.45 , y: currPos - (nodeHeight * 2)},
        style: ternary
    },
    {
        id: 'I1-G',
        type: 'LMRTNode',
        data: {},
        position: { x: maxX * 0.85, y: currPos - (nodeHeight * 3)},
        style: { ...whiteBox, ...{backgroundColor: "#a2a2a2", minWidth: "1px", width: "1px", height: "1px", padding: "0px"}},
    },
    {
        id: 'I1-1',
        type: 'LMRTNode',
        data: { label: labels.singly_linked_list },
        position: { x: maxX * 0.9 , y: currPos - (nodeHeight * 4)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'I1-2',
        type: 'LMRTNode',
        data: { label: labels.doubly_linked_list },
        position: { x: maxX * 0.9 , y: currPos - (nodeHeight * 3)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'I1-3',
        type: 'LMRTNode',
        data: { label: labels.queue },
        position: { x: maxX * 0.9 , y: currPos - (nodeHeight * 2)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'I1-4',
        type: 'LMRTNode',
        data: { label: labels.stacks },
        position: { x: maxX * 0.9 , y: currPos - nodeHeight},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'I1-5',
        type: 'LMRTNode',
        data: { label: labels.deque },
        position: { x: maxX * 0.9 , y: currPos},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'I2',
        type: 'LMRTNode',
        data: { label: labels.tree_data_structures },
        position: { x: maxX * 0.45 , y: currPos - nodeHeight},
        style: ternary
    },
    {
        id: 'I2-1',
        type: 'LMRTNode',
        data: { label: labels.trees },
        position: { x: maxX * 0.72 , y: currPos - (nodeHeight * 2)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'I2-2',
        type: 'LMRTNode',
        data: { label: labels.binary_trees },
        position: { x: maxX * 0.72 , y: currPos - nodeHeight},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'I2-3',
        type: 'LMRTNode',
        data: { label: labels.binary_search },
        position: { x: maxX * 0.72 , y: currPos},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'I2-4',
        type: 'LMRTNode',
        data: { label: labels.balanced_binary_trees },
        position: { x: maxX * 0.72 , y: currPos + nodeHeight },
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'I2-5',
        type: 'LMRTNode',
        data: { label: labels.heap_trees },
        position: { x: maxX * 0.72 , y: currPos + (nodeHeight * 2)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'I3',
        type: 'LMRTNode',
        data: { label: labels.graphs },
        position: { x: maxX * 0.45 , y: currPos},
        style: ternary
    },
    {
        id: 'I4',
        type: 'LMRTNode',
        data: { label: labels.functional_programming },
        position: { x: maxX * 0.45 , y: currPos + nodeHeight},
        style: ternary
    },
    // - Functional Programming
        //   - Lambdas
        //   - Callable Objects
        //   - Higher Order Functions
        //   - Closures
    {
        id: 'I4-1',
        type: 'LMRTNode',
        data: { label: labels.lambdas },
        position: { x: maxX * 0.65 , y: currPos + nodeHeight * 3},
        style: {...quaternary, ...{width: '160px'}},
        className: 'quaternary'
    },
    {
        id: 'I4-2',
        type: 'LMRTNode',
        data: { label: labels.callable_objects },
        position: { x: maxX * 0.65 , y: currPos + nodeHeight * 4},
        style: {...quaternary, ...{width: '160px'}},
        className: 'quaternary'
    },
    {
        id: 'I4-3',
        type: 'LMRTNode',
        data: { label: labels.higher_order_functions },
        position: { x: maxX * 0.65 , y: currPos + nodeHeight * 5},
        style: {...quaternary, ...{width: '160px'}},
        className: 'quaternary'
    },
    {
        id: 'I4-4',
        type: 'LMRTNode',
        data: { label: labels.closures },
        position: { x: maxX * 0.65 , y: currPos + nodeHeight * 6},
        style: {...quaternary, ...{width: '160px'}},
        className: 'quaternary'
    },
    {
        id: 'I5',
        type: 'LMRTNode',
        data: { label: labels.testing_qa },
        position: { x: maxX * 0.45 , y: currPos + (nodeHeight * 2)},
        style: ternary
    }
);


// #### Frontend Project 4 (Library App) (20)
// - Web API endpoints
// - Fetching server data
// - JSON Files
// - Web Client Storage
// - SPAs

currPos = currPos + nodeHeight * 6;

nodes.push(
    {
        id: 'J',
        type: 'LMRTNode',
        data: { label: labels.frontend_project_4, topLeftText: '<span style="margin-left: 2px;">⑩</span>', topRightText: labels.project, topRightStyle: recommendBoxStyle},
        position: { x: maxX * 0.2 , y: currPos},
        style: primary
    },
    {
        id: 'J1',
        type: 'LMRTNode',
        data: { label: labels.web_api_endpoints},
        position: { x: 0 , y: currPos - (nodeHeight * 2) },
        style: ternary
    },
    {
        id: 'J2',
        type: 'LMRTNode',
        data: { label: labels.fetching_server_data},
        position: { x: 0 , y: currPos - nodeHeight },
        style: ternary
    },
    {
        id: 'J3',
        type: 'LMRTNode',
        data: { label: labels.json_files},
        position: { x: 0 , y: currPos },
        style: ternary
    },
    {
        id: 'J4',
        type: 'LMRTNode',
        data: { label: labels.web_client_storage},
        position: { x: 0 , y: currPos + nodeHeight },
        style: ternary
    },
    {
        id: 'J5',
        type: 'LMRTNode',
        data: { label: labels.single_page_apps},
        position: { x: 0 , y: currPos + (nodeHeight * 2) },
        style: ternary
    },
);

// OOP, Database, Design Patterns (optional), Software Engineering Overview

currPos = currPos + nodeHeight * 6;

// oop
// Objects
// Encapsulation
// Abstraction
// Inheritance
// Polymorphism
// Generics

nodes.push(
    {
        id: 'K',
        type: 'LMRTNode',
        data: { label: labels.oop, topLeftText: '<span style="margin-left: 2px;">⑪</span>'},
        position: { x: maxX * 0.2 , y: currPos},
        style: primary
    },
    {
        id: 'K1',
        type: 'LMRTNode',
        data: { label: labels.oop_objects},
        position: { x: 0 , y: currPos - (nodeHeight * 2)},
        style: ternary
    },
    {
        id: 'K2',
        type: 'LMRTNode',
        data: { label: labels.oop_encapsulation},
        position: { x: 0 , y: currPos - nodeHeight},
        style: ternary
    },
    {
        id: 'K3',
        type: 'LMRTNode',
        data: { label: labels.oop_abstraction},
        position: { x: 0 , y: currPos},
        style: ternary
    },
    {
        id: 'K4',
        type: 'LMRTNode',
        data: { label: labels.oop_inheritance},
        position: { x: 0 , y: currPos + nodeHeight},
        style: ternary
    },
    {
        id: 'K5',
        type: 'LMRTNode',
        data: { label: labels.oop_polymorphism},
        position: { x: 0 , y: currPos + (nodeHeight * 2)},
        style: ternary
    },
    {
        id: 'K6',
        type: 'LMRTNode',
        data: { label: labels.oop_generics},
        position: { x: 0 , y: currPos + (nodeHeight * 3)},
        style: ternary
    },
    {
        id: 'K-A',
        type: 'LMRTNode',
        data: { label: labels.design_patterns, topRightText: labels.optional, topRightStyle: recommendBoxStyle},
        position: { x: maxX * 0.35 , y: currPos - (nodeHeight * 2)},
        style: green
    },
    {
        id: 'L',
        type: 'LMRTNode',
        data: { label: labels.databases, topLeftText: '<span style="margin-left: 2px;">⑫</span>'},
        position: { x: maxX * 0.75 , y: currPos},
        style: primary
    },
    {
        id: 'L1',
        type: 'LMRTNode',
        data: { label: labels.rdbms},
        position: { x: maxX * 0.95, y: currPos - nodeHeight},
        style: ternary
    },
    {
        id: 'L2',
        type: 'LMRTNode',
        data: { label: labels.sql},
        position: { x: maxX * 0.95, y: currPos},
        style: ternary
    },
    {
        id: 'L3',
        type: 'LMRTNode',
        data: { label: labels.relational_databases},
        position: { x: maxX * 0.95, y: currPos + nodeHeight},
        style: ternary
    },
    {
        id: 'M',
        type: 'LMRTNode',
        data: { label: labels.software_engineering, topLeftText: '<span style="margin-left: 2px;">⑬</span>'},
        position: { x: maxX * 0.75, y: currPos + (nodeHeight * 5)},
        style: primary
    },
);

// Backend Project 3, Backend Project 4, Backend Project 5, Join Career Support, Specialization In A Framework,

currPos = currPos + nodeHeight * 11;

nodes.push(
    {
        id: 'N',
        type: 'LMRTNode',
        data: { label: labels.backend_project_3, topLeftText: '<span style="margin-left: 2px;">⑭</span>', topRightText: labels.project, topRightStyle: recommendBoxStyle},
        position: { x: maxX * 0.55 , y: currPos},
        style: primary
    },
    // - World Wide Web
    // - Web Servers
    //   - NGINX
    // - Cloud VM
    //   - AWS EC2
    // - HTTP
    // - SSH
    // - SFTP
    // - Domains
    //   - Domain Registar
    //   - DNS Records
    //   - Subdomains
    // - TLS/SSL
    //   - HTTPS
    //   - LetsEncrypt
    {
        id: 'N1',
        type: 'LMRTNode',
        data: { label: labels.world_wide_web},
        position: { x: maxX * 0.55 , y: currPos - (nodeHeight * 9)},
        style: ternary
    },
    {
        id: 'N2',
        type: 'LMRTNode',
        data: { label: labels.web_servers},
        position: { x: maxX * 0.55 , y: currPos - (nodeHeight * 8)},
        style: ternary
    },
    {
        id: 'N2-1',
        type: 'LMRTNode',
        data: { label: labels.nginx},
        position: { x: maxX * 0.4 , y: currPos - (nodeHeight * 8)},
        style: { ...quaternary, ...{minWidth: "130px"}},
        className: 'quaternary'
    },
    {
        id: 'N3',
        type: 'LMRTNode',
        data: { label: labels.cloud_vm},
        position: { x: maxX * 0.55 , y: currPos - (nodeHeight * 7)},
        style: ternary
    },
    {
        id: 'N4',
        type: 'LMRTNode',
        data: { label: labels.http},
        position: { x: maxX * 0.55 , y: currPos - (nodeHeight * 6)},
        style: ternary
    },
    {
        id: 'N5',
        type: 'LMRTNode',
        data: { label: labels.ssh},
        position: { x: maxX * 0.55 , y: currPos - (nodeHeight * 5)},
        style: ternary
    },
    {
        id: 'N6',
        type: 'LMRTNode',
        data: { label: labels.sftp},
        position: { x: maxX * 0.55 , y: currPos - (nodeHeight * 4)},
        style: ternary
    },
    {
        id: 'N7',
        type: 'LMRTNode',
        data: { label: labels.domains},
        position: { x: maxX * 0.55 , y: currPos - (nodeHeight * 3)},
        style: ternary
    },
    {
        id: 'N7-1',
        type: 'LMRTNode',
        data: { label: labels.domain_registrar},
        position: { x: maxX * 0.4 , y: currPos - (nodeHeight * 4)},
        style: { ...quaternary, ...{minWidth: "130px"}},
        className: 'quaternary'
    },
    {
        id: 'N7-2',
        type: 'LMRTNode',
        data: { label: labels.dns_records},
        position: { x: maxX * 0.4 , y: currPos - (nodeHeight * 3)},
        style: { ...quaternary, ...{minWidth: "130px"}},
        className: 'quaternary'
    },
    {
        id: 'N7-3',
        type: 'LMRTNode',
        data: { label: labels.subdomains},
        position: { x: maxX * 0.4 , y: currPos - (nodeHeight * 2)},
        style: { ...quaternary, ...{minWidth: "130px"}},
        className: 'quaternary'
    },
    {
        id: 'N8',
        type: 'LMRTNode',
        data: { label: labels.tls_ssl},
        position: { x: maxX * 0.55 , y: currPos - (nodeHeight * 2)},
        style: ternary
    },
    {
        id: 'N8-1',
        type: 'LMRTNode',
        data: { label: labels.https},
        position: { x: maxX * 0.72 , y: currPos - (nodeHeight * 2.5)},
        style: { ...quaternary, ...{minWidth: "90px"}},
        className: 'quaternary'
    },
    {
        id: 'N8-2',
        type: 'LMRTNode',
        data: { label: labels.lets_encrypt},
        position: { x: maxX * 0.72 , y: currPos - (nodeHeight * 1.5)},
        style: { ...quaternary, ...{minWidth: "90px"}},
        className: 'quaternary'
    },
    {
        id: 'O',
        type: 'LMRTNode',
        data: { label: labels.backend_project_4, topLeftText: '<span style="margin-left: 2px;">⑮</span>', topRightText: labels.project, topRightStyle: recommendBoxStyle},
        position: { x: maxX * 0.2 , y: currPos},
        style: primary
    },
        // - OOP Web Applications
        // - Server-Side Rendering
        // - UML Diagrams
        // - GET/POST Methods
        // - Dynamic Content
        // - Reverse Proxy Servers
    {
        id: 'O1',
        type: 'LMRTNode',
        data: { label: labels.oop_web_applications},
        position: { x: maxX * 0.19 , y: currPos - (nodeHeight * 7)},
        style: {...ternary, ...{width: '170px'}}
    },
    {
        id: 'O2',
        type: 'LMRTNode',
        data: { label: labels.server_side_rendering},
        position: { x: maxX * 0.19 , y: currPos - (nodeHeight * 6)},
        style: {...ternary, ...{width: '170px'}}
    },
    {
        id: 'O3',
        type: 'LMRTNode',
        data: { label: labels.uml_diagrams},
        position: { x: maxX * 0.19 , y: currPos - (nodeHeight * 5)},
        style: {...ternary, ...{width: '170px'}}
    },
    {
        id: 'O4',
        type: 'LMRTNode',
        data: { label: labels.get_post_methods},
        position: { x: maxX * 0.19 , y: currPos - (nodeHeight * 4)},
        style: {...ternary, ...{width: '170px'}}
    },
    {
        id: 'O5',
        type: 'LMRTNode',
        data: { label: labels.dynamic_content},
        position: { x: maxX * 0.19 , y: currPos - (nodeHeight * 3)},
        style: {...ternary, ...{width: '170px'}}
    },
    {
        id: 'O6',
        type: 'LMRTNode',
        data: { label: labels.reverse_proxy_servers},
        position: { x: maxX * 0.19 , y: currPos - (nodeHeight * 2)},
        style: {...ternary, ...{width: '170px'}}
    }
);

currPos = currPos + nodeHeight * 7;

// backend project 5

// - 3 Tier Architecture

// - Model-View-Controller
// - Entity Relationships
//   - One-to-One
//   - One-to-Many
//   - Many-to-Many
// - Shell Commands
// - Data Processing
//   - DDL Queries
//   - DML Queries
// - Schema Scripting
// - Database Migrations
//   - Migration Based
//   - State Based
// - Data Seeding
// - URL Routing
// - Data Access Layer
//   - DAO
//   - ORM
// - Temporary Storage
//   - HTTP Cookies
//   - Client Storage
//   - Server Sessions
// - User Authentication
//   - Stateful Authentication
//     - Session IDs
//   - Stateless Authentication
//     - JWT
//     - oAUTH
// - Middleware
// - Web Security
//   - Safe Querying
//   - Input Validation
//   - Hashing
//   - CSRF Protection
//   - Injection Protection
//   - Signatures
//   - XSS Protection
// - Emailing
// - Process Scheduling
//   - Cron Jobs
nodes.push(
    {
        id: 'P',
        type: 'LMRTNode',
        data: { label: labels.backend_project_5, topLeftText: '<span style="margin-left: 2px;">⑯</span>', topRightText: labels.project, topRightStyle: recommendBoxStyle},
        position: { x: maxX * 0.2 , y: currPos},
        style: primary
    },
    {
        id: 'P1',
        type: 'LMRTNode',
        data: { label: labels.three_tier_architecture},
        position: { x: maxX * 0.45 , y: currPos - (nodeHeight * 5)},
        style: ternary
    },
    {
        id: 'P2',
        type: 'LMRTNode',
        data: { label: labels.entity_relationship},
        position: { x: maxX * 0.45 , y: currPos - (nodeHeight * 4)},
        style: ternary
    },
    {
        id: 'P2-1',
        type: 'LMRTNode',
        data: { label: labels.one_to_one},
        position: { x: maxX * 0.65 , y: currPos - (nodeHeight * 5)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P2-2',
        type: 'LMRTNode',
        data: { label: labels.one_to_many},
        position: { x: maxX * 0.65 , y: currPos - (nodeHeight * 4)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P2-3',
        type: 'LMRTNode',
        data: { label: labels.many_to_many},
        position: { x: maxX * 0.65 , y: currPos - (nodeHeight * 3)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P3',
        type: 'LMRTNode',
        data: { label: labels.model_view_controller},
        position: { x: maxX * 0.45 , y: currPos - (nodeHeight * 3)},
        style: ternary
    },
    {
        id: 'P4',
        type: 'LMRTNode',
        data: { label: labels.shell_commands},
        position: { x: maxX * 0.45 , y: currPos - (nodeHeight * 2)},
        style: ternary
    },
    {
        id: 'P5',
        type: 'LMRTNode',
        data: { label: labels.data_processing},
        position: { x: maxX * 0.45 , y: currPos - nodeHeight},
        style: ternary
    },
    {
        id: 'P5-1',
        type: 'LMRTNode',
        data: { label: labels.ddl_queries},
        position: { x: maxX * 0.65 , y: currPos - (nodeHeight * 1.5)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P5-2',
        type: 'LMRTNode',
        data: { label: labels.dml_queries},
        position: { x: maxX * 0.65 , y: currPos - (nodeHeight * 0.5)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P6',
        type: 'LMRTNode',
        data: { label: labels.schema_scripting},
        position: { x: maxX * 0.45 , y: currPos},
        style: ternary
    },
    {
        id: 'P7',
        type: 'LMRTNode',
        data: { label: labels.database_migrations},
        position: { x: maxX * 0.45 , y: currPos + nodeHeight},
        style: ternary
    },
    {
        id: 'P7-1',
        type: 'LMRTNode',
        data: { label: labels.migration_based},
        position: { x: maxX * 0.65 , y: currPos + (nodeHeight)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P7-2',
        type: 'LMRTNode',
        data: { label: labels.state_based},
        position: { x: maxX * 0.65 , y: currPos + (nodeHeight * 2)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P8',
        type: 'LMRTNode',
        data: { label: labels.data_seeding},
        position: { x: maxX * 0.45 , y: currPos + (nodeHeight * 2)},
        style: ternary
    },
    {
        id: 'P9',
        type: 'LMRTNode',
        data: { label: labels.url_routing},
        position: { x: maxX * 0.45 , y: currPos + (nodeHeight * 3)},
        style: ternary
    },
    {
        id: 'P10',
        type: 'LMRTNode',
        data: { label: labels.data_access_layer},
        position: { x: maxX * 0.45 , y: currPos + (nodeHeight * 4)},
        style: ternary
    },
    {
        id: 'P10-1',
        type: 'LMRTNode',
        data: {label: labels.dao},
        position: {x: maxX * 0.28, y: currPos + (nodeHeight * 3.5)},
        style: {...quaternary, ...{minWidth: "70px"}},
        className: 'quaternary'
    },
    {
        id: 'P10-2',
        type: 'LMRTNode',
        data: { label: labels.orm},
        position: { x: maxX * 0.28, y: currPos + (nodeHeight * 4.5)},
        style: { ...quaternary, ...{minWidth: "70px"}},
        className: 'quaternary'
    },
    {
        id: 'P11',
        type: 'LMRTNode',
        data: { label: labels.temporary_storage},
        position: { x: maxX * 0.45 , y: currPos + (nodeHeight * 5)},
        style: ternary
    },
    {
        id: 'P11-1',
        type: 'LMRTNode',
        data: { label: labels.http_cookies},
        position: { x: maxX * 0.65 , y: currPos + (nodeHeight * 4.5)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P11-2',
        type: 'LMRTNode',
        data: { label: labels.client_storage},
        position: { x: maxX * 0.65 , y: currPos + (nodeHeight * 5.5)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P11-3',
        type: 'LMRTNode',
        data: { label: labels.server_sessions},
        position: { x: maxX * 0.65 , y: currPos + (nodeHeight * 6.5)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P12',
        type: 'LMRTNode',
        data: { label: labels.user_authentication },
        position: { x: maxX * 0.02 - 5, y: currPos - (nodeHeight * 6) },
        style: { ...whiteBox, ...{height: nodeHeight * 3, width: "160px"}},
    },
    {
        id: 'P12-1',
        type: 'LMRTNode',
        data: { label: labels.stateful_authentication },
        position: { x: maxX * 0.02, y: currPos - (nodeHeight * 5) },
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P12-2',
        type: 'LMRTNode',
        data: { label: labels.stateless_authentication },
        position: { x: maxX * 0.02, y: currPos - (nodeHeight * 4) },
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P13',
        type: 'LMRTNode',
        data: { label: labels.middleware},
        position: { x: maxX * 0.02 , y: currPos - (nodeHeight * 3) + 10},
        style: ternary
    },
    {
        id: 'P14',
        type: 'LMRTNode',
        data: { label: labels.web_security},
        position: { x: maxX * 0.02 - 5, y: currPos - (nodeHeight * 2) + 10 },
        style: { ...whiteBox, ...{height: nodeHeight * 8, width: "160px"}},
    },
    {
        id: 'P14-1',
        type: 'LMRTNode',
        data: { label: labels.safe_querying },
        position: { x: maxX * 0.02, y: currPos - nodeHeight},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P14-2',
        type: 'LMRTNode',
        data: { label: labels.input_validation },
        position: { x: maxX * 0.02, y: currPos},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P14-3',
        type: 'LMRTNode',
        data: { label: labels.hashing },
        position: { x: maxX * 0.02, y: currPos + nodeHeight},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P14-4',
        type: 'LMRTNode',
        data: { label: labels.csrf},
        position: { x: maxX * 0.02, y: currPos + (nodeHeight * 2)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P14-5',
        type: 'LMRTNode',
        data: { label: labels.injection_protection },
        position: { x: maxX * 0.02, y: currPos + (nodeHeight * 3)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P14-6',
        type: 'LMRTNode',
        data: { label: labels.signing },
        position: { x: maxX * 0.02, y: currPos + (nodeHeight * 4)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P14-7',
        type: 'LMRTNode',
        data: { label: labels.xss },
        position: { x: maxX * 0.02, y: currPos + (nodeHeight * 5)},
        style: quaternary,
        className: 'quaternary'
    },
    {
        id: 'P15',
        type: 'LMRTNode',
        data: { label: labels.emailing},
        position: { x: maxX * 0.02 , y: currPos + (nodeHeight * 6) + 20},
        style: ternary
    },
    {
        id: 'P16',
        type: 'LMRTNode',
        data: { label: labels.process_scheduling},
        position: { x: maxX * 0.02 , y: currPos + (nodeHeight * 7) + 20},
        style: ternary
    },
    {
        id: 'P16-1',
        type: 'LMRTNode',
        data: { label: labels.cron_jobs},
        position: { x: maxX * 0.02 , y: currPos + (nodeHeight * 9) + 20},
        style: {...quaternary, ...{width: "150px"}},
        className: 'quaternary'
    },
);

// support and frameworks
currPos = currPos + nodeHeight * 8;

nodes.push(
    {
        id: 'Q',
        type: 'LMRTNode',
        data: { label: labels.career_support, topLeftText: '<span style="margin-left: 2px;">⑰</span>'},
        position: { x: maxX * 0.2, y: currPos},
        style: primary
    },
    {
        id: 'R',
        type: 'LMRTNode',
        data: { label: labels.backend_framework_specialization, topLeftText: '<span style="margin-left: 2px;">⑱</span>'},
        position: { x: maxX * 0.6, y: currPos},
        style: {...primary, ...{paddingLeft: "1rem"}}
    },
    {
        id: 'R-G',
        type: 'LMRTNode',
        data: { label: labels.team_dev_three, topRightText: labels.backend_optional, topRightStyle: recommendBoxStyle },
        position: { x: maxX * 0.633, y: currPos + (nodeHeight * 2)},
        style: green
    },
    // DJango -> Python
    // Laravel -> PHP
    // Express.js -> JS
    // Ruby on Rails -> Ruby
    // ASP.NET Core -> C#
    // Springboot -> Java
    // Rocket -> Rust
    {
        id: 'R1',
        type: 'LMRTNode',
        data: { label: labels.fw_django, topRightText: labels.lang_python, topRightStyle: recommendBoxStyle},
        position: { x: maxX * 0.95, y: currPos - (nodeHeight * 3)},
        style: green
    },
    {
        id: 'R2',
        type: 'LMRTNode',
        data: { label: labels.fw_laravel, topRightText: labels.lang_php, topRightStyle: recommendBoxStyle},
        position: { x: maxX * 0.96, y: currPos - (nodeHeight * 2)},
        style: green
    },
    {
        id: 'R3',
        type: 'LMRTNode',
        data: { label: labels.fw_express, topRightText: labels.lang_js, topRightStyle: recommendBoxStyle},
        position: { x: maxX * 0.97, y: currPos - nodeHeight},
        style: green
    },
    {
        id: 'R4',
        type: 'LMRTNode',
        data: { label: labels.fw_ruby_on_rails, topRightText: labels.lang_ruby, topRightStyle: recommendBoxStyle},
        position: { x: maxX * 0.98, y: currPos},
        style: green
    },
    {
        id: 'R5',
        type: 'LMRTNode',
        data: { label: labels.fw_asp_net_core, topRightText: labels.lang_csharp, topRightStyle: recommendBoxStyle},
        position: { x: maxX * 0.97, y: currPos + nodeHeight},
        style: dark
    },
    {
        id: 'R6',
        type: 'LMRTNode',
        data: { label: labels.fw_springboot, topRightText: labels.lang_java, topRightStyle: recommendBoxStyle},
        position: { x: maxX * 0.96, y: currPos + (nodeHeight * 2)},
        style: dark
    },
    {
        id: 'R7',
        type: 'LMRTNode',
        data: { label: labels.fw_rocket, topRightText: labels.lang_rust, topRightStyle: recommendBoxStyle},
        position: { x: maxX * 0.95, y: currPos + (nodeHeight * 3)},
        style: red
    }
);


export default nodes;
